import captureResourceTime from './resourceTime'
import capturePerformanceTiming from './performanceTiming'

export function performanceCapture() {
  if (process.env.NODE_ENV !== 'production') return
  window.addEventListener('load', () => {
    captureResourceTime()
    capturePerformanceTiming()
  })
}
